import { ReactElement } from 'react';
import Banner from './Banner';
import { useMenuWithCart } from '../../../contexts/MenuWithCart';
import { BannerVariant } from '../../../utils/config';

function AdminStatusBannerContainer(): ReactElement {
  const { menu } = useMenuWithCart();

  if (!menu?.statusMessage) {
    return (<></>);
  }

  return (
    <Banner
      bannerText={menu?.statusMessage}
      isVisible
      variant={BannerVariant.ADMIN_STATUS}
    />
  );
}

export default AdminStatusBannerContainer;
